import { render } from "./ShowProductPage.vue?vue&type=template&id=78592794&lang=html"
import script from "./ShowProductPage.vue?vue&type=script&lang=js"
export * from "./ShowProductPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__